import React, { useState } from "react";
import Container from "../../components/Container";
import TransparentContainer from "../../components/TransparentContainer";
import CheckBox from "../../components/CheckBox";
import RadioButtonsGroup from "../../components/RadioButtonsGroup";
import AddressAndCoordinates from "./AddressAndCoordinates";
import ImageDropdown from "../../components/ImageDropdown";
import SearchableDropdown from "./SearchableDropdown";
import Button from "../../components/Button";
import Form from "react-bootstrap/Form"; // Импортируем кнопку

function Information({
  setSelfPickUp,
  selfPickUp,
  paymentMethod,
  setPaymentMethod,
  addressAndCoordinates,
  setAddressAndCoordinates,
  dealId,
  typeOptions,
  typeRoof,
  setTypeRoof,
  setSelectedNomenclature,
  setDistanceFromFactory,
  distanceFromFactory,
  region,
  setRegion
}) {
  const [selectedManufacturer, setSelectedManufacturer] = useState("grand-line");
  const [isExpanded, setIsExpanded] = useState(false); // Состояние для управления видимостью
  const manufacturerOptions = [{ value: "grand-line", label: "Grand Line" }];
  const payments = [
    { value: "cash", label: "Наличные" },
    { value: "card", label: "Безналичный расчет" },
  ];

  return (
    <Container>
      <h2 className="fs-3 mb-4 text-start fst-italic text-secondary">
        Базовая информация
      </h2>
      <div
        className="d-flex justify-content-center align-items-center w-100 flex-wrap"
        style={{
          gap: "1%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "stretch",
        }}
      >
        {/* По умолчанию видно только "Выбор номенклатуры" и "Тип кровли" */}


        <TransparentContainer>
          <label className="form-check-label fs-4">Тип кровли</label>
          <ImageDropdown
            options={typeOptions}
            selectedOption={typeRoof}
            onSelect={setTypeRoof}
          />
        </TransparentContainer>

          <TransparentContainer>
              <label className="form-check-label fs-4">Выберите номенклатуру</label>
              <SearchableDropdown
                  onSelect={(option) => setSelectedNomenclature(option)}
              />
          </TransparentContainer>

          <TransparentContainer>
              <label className="form-check-label fs-4">Регион</label>
              <ImageDropdown
                  options={[{label: "Санкт-Петербург", value: "СПБ" }, {label: "Москва", value: "МСК"}, {label: "Краснодар", value: "КРД"}]}
                  selectedOption={region}
                  onSelect={setRegion}
              />
          </TransparentContainer>


          {/* Кнопка для разворачивания/сворачивания дополнительных полей */}
        <div style={{ width: "100%", textAlign: "center", margin: "10px 0" }}>
          <Button
            onClick={() => setIsExpanded(!isExpanded)}
            label={isExpanded ? "Свернуть" : "Развернуть доп.опции"}
          />
        </div>

        {/* Дополнительные поля, которые отображаются только при isExpanded === true */}
        {isExpanded && (
          <>
            <TransparentContainer>
              <CheckBox
                label="Самовывоз"
                onChange={(event) => setSelfPickUp(event.target.checked)}
                checked={selfPickUp}
                id="checkbox1"
              />
            </TransparentContainer>

            <TransparentContainer>
              <RadioButtonsGroup
                title="Форма оплаты"
                options={payments}
                name="radioGroup"
                selectedValue={paymentMethod}
                onChange={(event) => setPaymentMethod(event.target.value)}
              />
            </TransparentContainer>

            {!selfPickUp && (
              <TransparentContainer>
                <AddressAndCoordinates
                  addressAndCoordinates={addressAndCoordinates}
                  setAddressAndCoordinates={setAddressAndCoordinates}
                  setSelfPickUp={setSelfPickUp}
                  dealId={dealId}
                  setDistanceFromFactory={setDistanceFromFactory}
                  distanceFromFactory={distanceFromFactory}
                  region={region}
                />
              </TransparentContainer>
            )}

            <TransparentContainer>
              <label className="form-check-label fs-4">Производитель</label>
              <ImageDropdown
                options={manufacturerOptions}
                selectedOption={selectedManufacturer}
                onSelect={setSelectedManufacturer}
              />
            </TransparentContainer>
          </>
        )}
      </div>
    </Container>
  );
}

export default Information;